import React from 'react';
import PropTypes from 'prop-types';


class OutsideElementEventCatcher extends React.PureComponent {

  componentDidMount() {
    const { events } = this.props;
    document.addEventListener(`${events.join(' ')}`, this.handleClickOutside);
  }

  componentWillUnmount() {
    const { events } = this.props;

    document.removeEventListener(`${events.join(' ')}`, this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    const { callback } = this.props;

    if (this.reference.current && !this.reference.current.contains(event.target)) {
      callback();
    }
  };

  reference = React.createRef();

  render() {
    const { reference } = this;
    const { render: View } = this.props;

    return <View reference={ reference } />;
  }
}

OutsideElementEventCatcher.propTypes = {
  render: PropTypes.func.isRequired,
  events: PropTypes.arrayOf(PropTypes.string).isRequired,
  callback: PropTypes.func.isRequired
};

export default OutsideElementEventCatcher;
